import { IStore } from 'store/configureStore';

export const selectControllingOrgState = (state: IStore) => {
    return state.modules.settings.clientsSettings.clients.controllingOrg;
};
